import React from "react";
import styled from "styled-components";

const ExportExcelBtn = ({ onClick }) => {
  return (
    <StyledWrapper>
      <button className="excel-btn" onClick={onClick} aria-label="Export to Excel" title="Export to Excel">
        <span className="icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="white"
            width="20"
            height="20"
          >
            <path d="M448 0H160c-17.7 0-32 14.3-32 32v96H64c-17.7 0-32 14.3-32 32v288c0 35.3 28.7 64 64 64h288c17.7 0 32-14.3 32-32V352h64c17.7 0 32-14.3 32-32V64c0-35.3-28.7-64-64-64zM160 32h288c17.6 0 32 14.4 32 32v256h-64V96c0-17.7-14.3-32-32-32H160V32zm-32 96v48h-64V128c0-8.8 7.2-16 16-16h48zm208 352H96c-17.6 0-32-14.4-32-32V192h64v64c0 17.7 14.3 32 32 32h176v160c0 8.8-7.2 16-16 16zM210.3 303.6l-21.4 36.2-21.4-36.2H133l38.8 63.6-39.2 64.8h34.5l23-37.2 23 37.2h34.5l-39.2-64.8L247 303.6h-36.7z" />
          </svg>
        </span>
        <span>Export</span>
      </button>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .excel-btn {
    width: 116px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #217346;
    border: none;
    border-radius: 10px;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    color: white;
    transition: background-color 0.2s ease;
  }

  .excel-btn:hover {
    background-color: #1e633e;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export default ExportExcelBtn;
